import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = process.env.REACT_APP_SERVER_URL;

export const SendEmail = createApi({
    reducerPath: 'SendEmail',
    baseQuery: fetchBaseQuery({ baseUrl }),
    endpoints: (builder) => ({


        pricingMail: builder.mutation({
            query: ({ name, email, title, ans1, ans2 }) => {
                return {
                    url: `/mail/send`,
                    body: { name, email, title, ans1, ans2 },
                    method: 'Post',
                    credentials: 'include'
                }
            },

        }),
        arrangeMeeting: builder.mutation({
            query: ({ name, email, startTime, endTime, phone }) => {
                return {
                    url: `/arrange/meetup`,
                    body: { name, email, startTime, endTime, phone },
                    method: 'Post',
                    credentials: 'include'
                }
            },

        }),
        contactForm: builder.mutation({
            query: ({ selectedOptions = '', name, phone, email, answer, mxg, formUrl, countryName, slug, vacancy = false }) => {
                return {
                    url: `/contact/form`,
                    body: { selectedOptions, name, phone, email, answer, mxg, formUrl, countryName, slug, vacancy },
                    method: 'Post',
                    credentials: 'include'
                }
            },

        }),
        getUrl: builder.query({
            query: () => {
                return {
                    url: `/consultation`,
                    method: 'Get',
                }
            },

        }),

        AllMeetups: builder.query({
            query: () => {
                return {
                    url: `/meetup/list`,
                    method: 'Get',
                }
            },

        }),

    })
});

export const {

    usePricingMailMutation,
    useGetUrlQuery,
    useArrangeMeetingMutation,
    useContactFormMutation,
    useAllMeetupsQuery

} = SendEmail